// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"73":"502f77b2","271":"0ea239a9","350":"6fa6ae88","379":"1481bb4e","460":"2d6bed4c","537":"11a615d2","645":"ccfb9618","711":"334054d5","822":"f4a20b43","866":"e69adc0a"}[chunkId] + ".chunk.css";
};